import { Skeleton } from '@ordo/ui/skeleton'

import { InventoryTable } from '@/components/cafeteria/inventory-table'
import { OrdoPageContainer } from '@/components/ordo-page-container'

/**
 * Cold-load skeleton for the Inventory page, block-for-block: the Serve Now
 * header (page icon, the day, its chevrons) + Edit button, the mealtime tab strip, and the table with skeleton
 * rows — `InventoryTable loading`, the same body the page shows while a
 * mealtime's rows load, so the swap is imperceptible.
 */
export function CafeteriaInventorySkeleton() {
  return (
    <OrdoPageContainer>
      <div className="mb-6 flex items-center justify-between gap-4 border-b border-border pb-4" aria-busy="true">
        <div className="flex items-center gap-3">
          {/* Page icon, the day title, the two day chevrons (the Serve Now header). */}
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-8 w-28" />
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-9 w-9 rounded-md" />
        </div>
        <Skeleton className="h-9 w-36" />
      </div>
      <div className="flex flex-col gap-6">
        <div className="flex gap-1 border-b border-border">
          <Skeleton className="mx-4 mb-2.5 mt-2.5 h-5 w-16" />
          <Skeleton className="mx-4 mb-2.5 mt-2.5 h-5 w-16" />
        </div>
        <InventoryTable rows={[]} loading edit={null} />
      </div>
    </OrdoPageContainer>
  )
}
